import RemoteImpl from '@threeskye/global/dist/RemoteImpl';
import SessionStorage from '@threeskye/global/dist/SessionStorage';

const remote = new RemoteImpl();
export const useRemote = () => remote;

const storage = new SessionStorage(remote);
export const useStorage = () => storage;